const Artifact = require('../../contracts/src/contracts/test/NFT.json')
export const ABI = Artifact.abi
export const ContractAddress = Artifact.address
